import React from 'react';
import type { V2Guard, V2Route } from '../units/types';

/** 旧 /news と同じく組織の enable_news */
const guard: V2Guard = { kind: 'feature', feature: 'enable_news' };

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  { path: 'news', Component: React.lazy(() => import('./NewsListPage')), guard },
  { path: 'news/:id', Component: React.lazy(() => import('./NewsDetailPage')), guard, layout: 'focus' },
];

export default routes;
